module.exports = __webpack_public_path__ + "static/media/logout.fd39c73c.svg";